import {updateIfNeeded} from '@packages/utilities/POJORecordUtils';
import {weakMemo} from '@packages/utilities/memo';

import type {
  ComponentForm,
  ComponentForms,
} from '@packages/systems/flows/types';

const _mergeComponentForms_memo = weakMemo(function mergeComponentForms_memoA(
  componentFormsA: ComponentForms
) {
  return weakMemo(function mergeComponentForms_memoB(
    componentFormsB: ComponentForms
  ) {
    const mergedComponentForms = updateIfNeeded(
      componentFormsA,
      componentFormsB
    );

    const result: Record<string, ComponentForm> = {};
    for (const componentId in mergedComponentForms) {
      const componentForm = mergedComponentForms[componentId];
      // @ts-expect-error - TS18048 - 'componentForm' is possibly 'undefined'.
      if (componentForm.forms.length > 0) {
        // @ts-expect-error - TS2322 - Type 'ComponentForm | undefined' is not assignable to type 'ComponentForm'.
        result[componentId] = componentForm;
      }
    }

    return result;
  });
});

export function mergeComponentForms(
  componentFormsA: ComponentForms,
  componentFormsB: ComponentForms
): ComponentForms {
  return _mergeComponentForms_memo(componentFormsA)(componentFormsB);
}
